import { resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, createVNode as _createVNode, Fragment as _Fragment, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "ForecastingPlanning bg-white rounded flex flex-col justify-between" }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("div", { class: "px-4 py-3 border-b border-gray-200" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "font-semibold uppercase" }, "Планирование")
], -1)
const _hoisted_3 = {
  key: 0,
  class: "px-4 py-3 text-gray-400 text-xs flex flex-col items-center justify-center select-none"
}
const _hoisted_4 = /*#__PURE__*/_createElementVNode("p", { class: "text-red-500" }, " При получении данных прогнозирования авто произошла ошибка ", -1)
const _hoisted_5 = { key: 2 }
const _hoisted_6 = { class: "flex items-center justify-between px-4 py-6 border-t border-gray-200" }
const _hoisted_7 = /*#__PURE__*/_createElementVNode("i", { class: "fas fa-arrow-right" }, null, -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_cars_more_modal = _resolveComponent("cars-more-modal")!
  const _component_loader = _resolveComponent("loader")!
  const _component_new_button = _resolveComponent("new-button")!
  const _component_cars_prediction = _resolveComponent("cars-prediction")!
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (_ctx.cars_state.is_opened)
      ? (_openBlock(), _createBlock(_component_cars_more_modal, {
          key: 0,
          cars: _ctx.state.prediction_cars,
          loading: _ctx.state.is_loading,
          onCancel: _ctx.toggleMore
        }, null, 8, ["cars", "loading", "onCancel"]))
      : _createCommentVNode("", true),
    _createElementVNode("div", null, [
      _hoisted_2,
      (_ctx.state.is_loading || _ctx.state.is_failed || _ctx.state.prediction_cars.length === 0)
        ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
            (_ctx.state.is_loading)
              ? (_openBlock(), _createBlock(_component_loader, {
                  key: 0,
                  class: "primary"
                }))
              : (_ctx.state.is_failed)
                ? (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                    _hoisted_4,
                    _createVNode(_component_new_button, {
                      class: "mt-1 NewButton--outline",
                      onClick: _ctx.loadPredictionCars
                    }, {
                      default: _withCtx(() => [
                        _createTextVNode(" Обновить ")
                      ]),
                      _: 1
                    }, 8, ["onClick"])
                  ], 64))
                : (_ctx.state.prediction_cars.length === 0)
                  ? (_openBlock(), _createElementBlock("p", _hoisted_5, "Нет данных"))
                  : _createCommentVNode("", true)
          ]))
        : (_openBlock(), _createBlock(_component_cars_prediction, {
            key: 1,
            cars: _ctx.state.prediction_cars
          }, null, 8, ["cars"]))
    ]),
    _createElementVNode("div", _hoisted_6, [
      _createVNode(_component_new_button, {
        class: "NewButton--secondary mr-4",
        disabled: _ctx.state.is_loading,
        onClick: _ctx.toggleMore
      }, {
        default: _withCtx(() => [
          _createTextVNode(" Подробнее ")
        ]),
        _: 1
      }, 8, ["disabled", "onClick"]),
      _createVNode(_component_router_link, { to: "/new-dispatcher/planning" }, {
        default: _withCtx(() => [
          _createVNode(_component_new_button, null, {
            "icon-right": _withCtx(() => [
              _hoisted_7
            ]),
            default: _withCtx(() => [
              _createTextVNode(" Начать планирование ")
            ]),
            _: 1
          })
        ]),
        _: 1
      })
    ])
  ]))
}